export const USER_LOGED_IN = 'USER_LOGED_IN';
export const USER_LOGED_OUT = 'USER_LOGED_OUT';

export const CHECK_NEW_MESSAGSES = 'CHECK_NEW_MESSAGSES';
